// Configuration i18n Revyo — 4 langues : FR (défaut), EN, ES, IT.
// Centralise la liste des langues supportées, les libellés UI (drapeau + label
// natif) et la table de correspondance pays → langue utilisée par la détection
// front (fallback navigator) et par le backend /api/i18n/detect (geoip-lite).

export const SUPPORTED_LANGS = ['fr', 'en', 'es', 'it'];
export const DEFAULT_LANG = 'fr';

export const LANG_LABELS = {
  fr: { label: 'Français', flag: '🇫🇷', native: 'Français' },
  en: { label: 'English',  flag: '🇬🇧', native: 'English'  },
  es: { label: 'Español',  flag: '🇪🇸', native: 'Español'  },
  it: { label: 'Italiano', flag: '🇮🇹', native: 'Italiano' },
};

// Mapping pays ISO-2 → langue Revyo. Doit rester aligné avec backend/routes/i18n.js.
// - Francophonie ciblée (FR/BE/CH/LU/MC)
// - Anglais = défaut "international" (DE/AT/NL/SE/NO/DK/FI tombent sur EN tant
//   qu'on n'a pas ces langues). UK/US/IE/AU/NZ/CA évidents.
// - Hispanophones LATAM + ES
// - Italophones (IT/SM/VA)
export const COUNTRY_TO_LANG = {
  FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', MC: 'fr',
  GB: 'en', US: 'en', IE: 'en', AU: 'en', NZ: 'en', CA: 'en',
  NL: 'en', SE: 'en', NO: 'en', DK: 'en', FI: 'en', DE: 'en', AT: 'en',
  ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es',
  IT: 'it', SM: 'it', VA: 'it',
};

export function languageFromCountry(country) {
  if (!country) return DEFAULT_LANG;
  return COUNTRY_TO_LANG[country.toUpperCase()] || 'en';
}
